import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=725b87a7&scoped=true&"
import script from "./Cookie.vue?vue&type=script&lang=js&"
export * from "./Cookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b87a7",
  null
  
)

export default component.exports